import React, {
    useContext,
    useEffect,
    useState,
    useMemo
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from "../router"

import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import * as CONSTANTS from "../constants";

import LoadingIndicator from '../components/loading-indicator';

export default function TicketTypeSelect(props) {

    const {notification, setNotification} = useContext(NotificationContext);

    const pricelist = useMemo(() => {
        return props.pricelist
    }, [props.pricelist]);

    const [currentTicket, setCurrentTicket] = useState(null);
    const [nonCurrent, setNonCurrent] = useState(null);
    
    const patchTicketType = useMutation({
        mutationFn: (selectedId) => QUERIES.patchTicketType(props.ticket.id, selectedId),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
            if (props.setMessage) props.setMessage("Concession has been applied.")
            if (props.setInEditMode) props.setInEditMode(false);
        },
    });

    useEffect(() => {
        if (!pricelist || !props.ticket) return;

        const all_ticket_types = UTILS.getTicketsByBand(props.ticket.band.name, pricelist);
        const current_ticket = all_ticket_types?.find((ticket) => ticket.ticketType.name == props.ticket.ticketType.name);
        const non_current_ticket_types = all_ticket_types?.filter((ticket) => ticket.ticketType.name != props.ticket.ticketType.name);

        setCurrentTicket(current_ticket);
        setNonCurrent(non_current_ticket_types);
        
    }, [pricelist, props.ticket]);

    return (
        <label onClick={() => {if (props.setMessage) props.setMessage(null)}} 
                htmlFor={`selectedTicket${props.ticket.id}`} 
                className='select-ticket-type--select'>
            <span className='sr-text'>Change the ticket type</span>
            {currentTicket ?
                    <select id={`selectedTicket${props.ticket.id}`} 
                            name={`selectedTicket${props.ticket.id}`}
                            onChange={(e) => {patchTicketType.mutateAsync(e.target.value)}}>
                        <option value={currentTicket.ticketType.id}>{currentTicket.ticketType.name} £{(currentTicket.amount).toFixed(2)}</option>
                        {nonCurrent?.map((ticket) => (
                            <option key={ticket.ticketType.id} value={ticket.ticketType.id}>{ticket.ticketType.name} £{ticket.amount.toFixed(2)}</option>
                        ))}
                    </select>
                : <LoadingIndicator />
            }
        </label>
    );
}